module.exports = __webpack_public_path__ + "static/img/成果录入.d3dbb52a.svg";